import { useTranslation } from 'react-i18next';
import { FilesCloudUpload } from 'modules/files';

interface LeadEventAttachCloudProps {
    disabled?: boolean;
    progress: number | boolean;
    files: File[];
    setFiles: React.Dispatch<React.SetStateAction<File[]>>;
}

const LeadEventAttachCloud = ({ disabled = false, progress, files, setFiles }: LeadEventAttachCloudProps) => {
    const { t } = useTranslation(['Leads', 'common']);

    return (
        <FilesCloudUpload
            disabled={disabled}
            progress={progress}
            files={files}
            setFiles={setFiles}
            label={t('leadStatus.labelAttach')}
            buttonLabel={t('leadStatus.btnAttach')}
            uploadingLabel={t('common:buttons.uploading')}
        />
    );
};

export default LeadEventAttachCloud;
